import { styled } from '@mui/material';

import { CARD_MAX_WIDTH } from '../../../utils/sizes.utils';
import { Button } from '../../button/button.component';

export const StyledCarouselCardContent = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
});

export const StyledCarouselCardActions = styled('div')(
	({
		theme: {
			palette: { sizes },
		},
	}) => ({
		padding: `0 ${sizes.size_2}px`,
	}),
);

export const StyledCarouselCardRoot = styled('div')(
	({
		theme: {
			palette: {
				boxShadow,
				sizes,
				borderRadius,
				colorScheme: {
					colorVariables: { colorPrimary, colorDarkShadow },
				},
			},
		},
	}) => ({
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		height: '100%',
		maxWidth: CARD_MAX_WIDTH,
		margin: '0 auto',
		padding: `0 0 ${sizes.size_2}px`,
		borderRadius: borderRadius.card,
		boxShadow: boxShadow.angle.xsmall,
		backgroundColor: 'white',
		border: `1px solid ${colorDarkShadow}`,
		overflow: 'hidden',
		'&:focus-visible': {
			outline: `2px solid ${colorPrimary}`,
			outlineOffset: 2,
			transition: 'outline 0s',
			boxShadow: 'none',
		},
	}),
);

export const StyledCarouselCardButton = styled(Button)({ width: '100%' });
